import { useQuery } from '@tanstack/react-query'
import { UseConexaQuery } from './types'

export const useConexaQuery = <T>(options: UseConexaQuery<T>) => {
  const { service, queryKey, config } = options

  const context = useQuery<T>(
    [...queryKey],
    async () => {
      const response = await service()

      return response
    },
    {
      ...config,
    },
  )

  return context
}
